import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
// import Accordion from './Accordion';
// import Tab from './Tab';
// import SpNavi from './SpNavi';
import ToTop from './ToTop';
// import DropDownMenu from './DropDownMenu';
// import BlockLink from './BlockLink';
// import Gmap from './Gmap';
import bowser from 'bowser';
// import matchheight from 'jquery-match-height';
// import link_icon from './link_icon';
import inview from 'jquery-inview';
import FloatAnimation from './FloatAnimation';
import slick from 'slick-carousel';

if(bowser.msie === true) {
	let version = 'ie_'+Math.floor(bowser.version);
	$('body').addClass('ie '+version);
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}

if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
// let param = {
// 	target:'#spnavi',
// 	trigger:'.btn_sp_navi',
// 	filter:'resposive_flg',
// 	speed:200
// };
// const spnavi = new SpNavi(param);
// spnavi.exec();

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
let param = {
	target : ".float_nav_area",
	stop_at : ".global_footer",
	fixer : 400,
};

const totop = new ToTop(param);
totop.exec();

let param_won = {
	target : "#wovn-translate-widget",
	stop_at : ".global_footer",
	fixer : 400,
};

const totop_won = new ToTop(param_won);
totop_won.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
// link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// import instagram from './instagram';
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');


/* ===============================================
#	global header
=============================================== */
const _w = $(window);
_w.on("load scroll",function(){
	let header = $(".js-global_header"),
		mvHeight = $(".mv").height(),
		scroll = $(this).scrollTop();
	if(scroll > mvHeight){
		header.addClass("is-show");
		$('#wovn-translate-widget').addClass('-is-display');
	}else{
		header.removeClass("is-show");
		$('#wovn-translate-widget').removeClass('-is-display');
	}
});




/* ===============================================
#	img lazyload
=============================================== */
$(function(){
	$(".js-lazyload").lazyload({
		effect : 'fadeIn',
		effect_speed: 3000
	});
});

/* ===============================================
#	mv
=============================================== */
/*
$(".js-mv-anim").on("inview",function(){
	const _this = $(this);
	if(!(_this.hasClass("animated"))){

		let tl = new TimelineMax({
			paused:false,
			onComplete:function(){
				_this.addClass("animated");
			}
		});
		tl.set(".mv-mask",{className:"+=is-show"});
		tl.set(".mv-photo,.mv-text",{className:"+=is-show"},1);
		tl.set(".mv-mask",{className:"+=is-slide"},1.5);
	}
});
*/
/*
//random image
var selectRandomMv = ()=>{
	const images = [];
	let num = 4;
	for(let i = 0; i < num; i++){
		images[i] =`./build/images/mv_${i}.jpg`;
	}
	let result = (images[Math.floor(Math.random() * images.length)]);
	$(".mv-photo").css("background-image",`url(${result})`);
}
*/

//selectRandomMv();
/* ===============================================
#	inview
=============================================== */

/**/
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty('--vh', `${vh}px`);


const lct = $('.left-col').offset().top;
const lch = $('.left-col').height();
const lcb = lct + lch;
$(window).on('resize load',function(){

	$('.left-col').css('bottom','');
	$('.left-col').css('position','');
	$('.left-col').css('top','');
	//各値を取得
	let wh = $(window).height();
	let ww = $(window).width();
	let ftt = $('.global_footer').offset().top;
	let fth = $('.global_footer').height();
	let ftb = ftt + fth;

	$(window).on('scroll',function(){

		if(ww >= 769) {
			let ws = $(window).scrollTop();
			let wh = $(window).height();
			let wb = ws + wh; //window下
			if(wb >= lcb) {
				$('.left-col').addClass('_fix');
			}else{
				$('.left-col').removeClass('_fix');
			}
			if(wb >= ftt) {
				if(wh <= lcb){
					$('.left-col').css({
						'position':'absolute',
						'bottom': fth
					})
				}else{
					let lcit = $('.left-col-img').offset().top;
					let lcih = $('.left-col-img').height();
					let lcib = lcit + lcih;
					if(lcib >= ftt) {
						$('.left-col').css({
							'position':'absolute',
							'bottom': fth,
							'top':''
						})
					}
				}
			}else{
				if(wh <= lch){
					$('.left-col').css({
						'bottom':'0'
					})
					if($('.left-col').hasClass('_fix')){
						$('.left-col').css({
							'position':'fixed'
						})
					}else{
						$('.left-col').css({
							'position':''
						})
					}
				}else{
					$('.left-col').css({
						'top':'0'
					})
					if($('.left-col').hasClass('_fix')){
						$('.left-col').css({
							'position':'fixed'
						})
					}else{
						$('.left-col').css({
							'position':'',
							'top':''
						})
					}
				}
			}
		}
	})
})

$(window).on('resize load',function(){
	let wh = $(window).height();
	let ww = $(window).width();
	if(ww >= 768) {
		switch(true) {
			case 700 <= wh && wh <= 800:
				$('.mv-logo').css('margin','20vh auto 0');
				break;
			case 630 <= wh && wh <= 700:
				$('.mv-logo').css('margin','15vh auto 0');
				break;
			case 590 <= wh && wh <= 630:
				$('.mv-logo').css('margin','10vh auto 0');
				break;
			case 560 <= wh && wh <= 590:
				$('.mv-logo').css('margin','5vh auto 0');
				break;
			case 0 <= wh && wh <= 560:
				$('.mv-logo').css('margin','0vh auto 0');
				break;
			default:
				$('.mv-logo').css('margin','');
		}
	}
})

$(window).on('resize load',function(){
	let ww = $(window).width(),
		wh = $(window).height(),
		wh_i = $(window).innerHeight();
	if(700 <= ww && ww <= 768) {
		if(wh >= 0) {
			$('.mv').css('height', wh - (wh - wh_i));
		}else{
			$('.mv').css('height', wh_i);
		}
	}
})

/* ===============================================
#	ロード時フェードイン
=============================================== */
$(window).on("load",function(){
	$("#wrap").animate({opacity:1},1500);
})
